import { render, staticRenderFns } from "./ManualReturn.vue?vue&type=template&id=348ff783"
import script from "./ManualReturn.vue?vue&type=script&lang=js"
export * from "./ManualReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports